const investmentFundLang = {
	onglet_performance: {
		tag: 'investment.fund.onglet_performance',
		fr: 'Performance',
		en: 'Performance',
	},
	onglet_documents: {
		tag: 'investment.fund.onglet_documents',
		fr: 'Documents',
		en: 'Documents',
	},
	onglet_operations: {
		tag: 'investment.fund.onglet_operations',
		fr: 'Opérations',
		en: 'Operations',
	},
	onglet_informations_contacts: {
		tag: 'investment.fund.onglet_informations_contacts',
		fr: 'Informations',
		en: 'Informations',
	},
	onglet_informations_assets: {
		tag: 'investment.fund.onglet_informations_assets',
		fr: 'Actifs',
		en: 'Assets',
	},
	title_performance: {
		tag: 'investment.fund.title_performance',
		fr: 'Performance',
		en: 'Performance',
	},
	title_documents: {
		tag: 'investment.fund.title_documents',
		fr: 'Documents',
		en: 'Documents',
	},
	title_operations: {
		tag: 'investment.fund.title_operations',
		fr: 'Opérations',
		en: 'Operations',
	},
	title_informations: {
		tag: 'investment.fund.title_informations',
		fr: 'Informations',
		en: 'Informations',
	},
	title_assets: {
		tag: 'investment.fund.title_assets',
		fr: 'Actifs',
		en: 'Assets',
	},
	subtitle_assets_reporting_period: {
		tag: 'investment.fund.subtitle_assets_reporting_period',
		fr: 'Période de reporting : {{reportingPeriod}}',
		en: 'Reporting period: {{reportingPeriod}}',
	},
	label_all_sub_portfolios: {
		tag: 'investment.fund.label_all_sub_portfolios',
		fr: 'Tous les cantons / portefeuille',
		en: 'All sub portfolios',
	},
	label_all_sub_portfolios_tooltip: {
		tag: 'investment.fund.label_all_sub_portfolios_tooltip',
		fr: 'Subdivision du portefeuille d’un investisseur selon ses objectifs, ses stratégies ou son organisation. Ces subdivisions sont définies par l’investisseur.',
		en: 'Division of an investor portfolio based upon its objectives, strategies or organization. It is defined by the investor.',
	},
	x_sub_portfolios: {
		tag: 'investment.filter.x_sub_portfolios',
		fr: '{{count}} cantons sélectionnés',
		en: '{{count}} sub portfolios',
		plurals: {
			zero: {
				fr: 'Aucune sélection',
				en: 'No selection',
			},
			one: {
				fr: '{{count}} canton sélectionné',
				en: '{{count}} sub portfolio selected',
			},
			other: {
				fr: '{{count}} cantons sélectionnés',
				en: '{{count}} sub portfolios selected',
			},
		},
	},
	text_no_data_available_yet: {
		tag: 'investment.fund.text_no_data_available_yet',
		fr: 'Pas de données disponibles pour le moment',
		en: 'No data available yet',
	},
	text_no_graph_when_no_fund: {
		tag: 'investment.fund.text_no_graph_when_no_fund',
		fr: 'Pas de graphique car pas de fonds',
		en: 'No graph when no fund',
	},
	text_no_graph_when_investments_only_in_liquidated_funds: {
		tag: 'investment.fund.text_no_graph_when_investments_only_in_liquidated_funds',
		fr: 'Aucun investissement dans des fonds non liquidés',
		en: 'No investment in unliquidated funds',
	},
	text_no_graph_when_multiple_currencies: {
		tag: 'investment.fund.text_no_graph_when_multiple_currencies',
		fr: 'Pas de graphique en cas de devises mutiples',
		en: 'No graph when multiple currencies',
	},
	title_portfolio_synthesis: {
		tag: 'investment.fund.title_portfolio_synthesis',
		fr: 'Synthèse du portefeuille',
		en: 'Portfolio synthesis',
	},
	title_my_holdings: {
		tag: 'investment.fund.title_my_holdings',
		fr: 'Mes positions',
		en: 'My holdings',
	},
};

export default investmentFundLang;
